;(function($){

    function Modal() {

        $("#modal").iziModal({
            closeOnEscape: true,
            closeButton: true,
            padding: 25,
            timeout:false,
        });

        $(window).on('load',function(){
            $('#modal').iziModal('open',event);
        });
       
    }

   	new Modal();

}(jQuery));